import React from 'react'

export const CommunityImpactIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#0D9488', size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    stroke={color}
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <title>Community Impact</title>
    {/* The outer "tree" or "trophy" shape */}
    <path d='M18.6 6.4a5 5 0 0 0-13.2 0'></path>
    <path d='M6 10H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2'></path>
    <path d='M18 10h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2'></path>
    <path d='M8 22h8'></path>

    {/* A clean "community/people" icon in the center */}
    <circle cx='12' cy='13' r='3'></circle>
    <path d='M17 20s-2-2-5-2-5 2-5 2'></path>
  </svg>
)
